<!-- 创建时间2023/06/19 16:55:41 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述： -->
<template>
  <div>
    <yxt-radio-group v-model="permissionType" :disabled="disabled">
      <yxt-radio :label="0">{{ $t('pc_biz_kng_lbl_authwithcatalog'/** 跟随分类浏览权限 */) }}</yxt-radio>
      <div class="yxtbiz-flex-center mt6">
        <yxt-radio class="mr10" :label="1">{{ $t('pc_kng_upload_lbl_browse_allow'/** 单独设置允许浏览 */) }}</yxt-radio>
        <yxt-tooltip
          max-width="400"
          effect="dark"
          placement="bottom"
          :content="$t('pc_kng_upload_lbl_browse_allowtip' /*设置后即使无目录浏览权限也支持浏览*/)"
        >
          <yxt-svg
            class="hand v-mid color-gray-6"
            width="16px"
            height="16px"
            icon-class="icons/question-cirlce-o"
          />
        </yxt-tooltip>
      </div>
    </yxt-radio-group>
    <auth-selector
      v-if="permissionType === 1"
      class="mt10 ml24"
      :permissions="permissions"
      :dataPermissionCode="isCourse ? 'kcgl_Course_authority_selection_scope' : 'kjgl_Courseware_browsing_permission_selection'"
      :disabled="disabled"
      @update="update"
    />
  </div>
</template>

<script>
import authSelector from './auth-selector.vue';
export default {
  components: { authSelector },
  name: 'form-browse-auth',
  props: {
    value: {
      type: Number,
      default: 0
    },
    permissions: {
      type: Array,
      default: () => []
    },
    isCourse: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    permissionType: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    update(val) {
      this.$emit('update:permissions', val);
    }
  }
};
</script>